module.exports = __webpack_public_path__ + "media/images/CARTE_CADEAU-88f0372c94d61b8cb1733432a76a50fb.svg";